export type PathwayAddModalItem = {
  id: number
  name: string
}

export const OLD_PATHWAYS_COUNT = 5
